import { useFormContext } from 'react-hook-form';
import {
    IExpense,
    NON_TAX_RETAINED,
    REQUIRE_TAX,
    TAX,
    TAX_RETAINED,
} from './expense-form';
import { useCalculateExpenseTotal } from './use-calculate-expense-total';

export function useSetExpenseTaxRequirement() {
    const rx = useFormContext<IExpense>();
    const { calculateExpenseTotal } = useCalculateExpenseTotal();

    const setExpenseTaxRequirement = (required: boolean) => {
        rx.setValue(REQUIRE_TAX, required, {
            shouldDirty: true,
            shouldValidate: true,
        });

        if (!required) {
            const options = {
                shouldDirty: true,
                shouldValidate: true,
            };
            rx.setValue(TAX, 0, options);
            rx.setValue(TAX_RETAINED, 0, options);
            rx.setValue(NON_TAX_RETAINED, 0, options);
        }

        calculateExpenseTotal();
    };

    return { setExpenseTaxRequirement };
}
